export interface StatsStatus {
    id: number;
    value: string;
}

export const STATS_STATUSES: StatsStatus[] = [
    { id: 1, value: "BAT not send" },
    { id: 2, value: "BAT sent, no approved" },
    { id: 3, value: "BAT approved" },
    { id: 4, value: "Campaign scheduled" },
    { id: 5, value: "Campaign sent" },
    { id: 6, value: "Campaign billed" },
    { id: 7, value: "Campaign Cancelled" },
];
